import React, { Fragment } from "react"
import {Link} from 'react-router-dom'
import Slider from "react-slick";
import moment from 'moment'
import './eventSlide.css'
const slideItem=(props,index)=>{
    return (<div key={index}  className="hero-area bg"><div className="row">
    <div className="col-md-10">
        <div className="block">
            <h1>{props.eventName||'Event'}</h1>
                <p>{props.longDesc||'Description .......'}</p>
            <div>
                <Link to={"/parent/eventpayment"}  className="btn btn-success" role="button">Pay Now</Link>
            </div>
        </div>
    </div>
    <div className="col-md-2">
                    <div className="counter text-center">
                        <ul id="countdown_dashboard">
                            <li>
                                <div className="dash days_dash">
                                    <div className="digit">
                                    <span className="dash_title">Start Date</span>
                                    <div className="bottom" style={{display: "block"}}>{moment(props.startDate).format('YYYY/MM/DD')}</div>
                                    </div>                                    
                                    
                                </div>
                            </li>                            
                            <li>
                                <div className="dash minutes_dash">                                    
                                    <div className="digit">
                                    <span className="dash_title">End Date</span>
                                    <div className="bottom" 
                                    style={{display: "block"}}>{moment(props.endDate).format('YYYY/MM/DD')}</div></div>                                   
                                    
                                </div>
                            </li>                            
                        </ul>
                    </div>
            </div>
        </div>
</div>)
}
class EventSlider extends React.Component{
    render(){
        const settings = {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 2000,
            autoplaySpeed: 3000
          };
        return(<Fragment>
         <Slider {...settings}>
             {
                 this.props.events.map((event,k)=>{
                     return slideItem(event,k)
                 })    
             }
         </Slider>
        

        </Fragment>)
    }
}
export default EventSlider;


// WEBPACK FOOTER //
// ./src/components/Parent/eventSlider/EventSlider.jsx